import { AddressType } from '../../address/models/address.model'
import useAddress from '../hooks/useAddress'

export default function useAddressPicker(id: string, addressType: AddressType) {
  const { address } = useAddress(id, addressType)
  const disableFields = !!(address.gescal && address.number)

  return { disableFields }
}
